; (function () {
  'use strict'

  angular
    .module('deskfy.arts')
    .directive('deleteSectionDialog', deleteSectionDialogDirective)

  /* @ngInject */
  function deleteSectionDialogDirective () {
    return {
      restrict: 'E',
      templateUrl: '/arts/dialogs/delete-section/delete-section-dialog.html?$$REVISION$$'
    }
  }
})()
